import {
  Fragment,
  type FC
} from 'react';
import {
  Box
} from '@mui/joy';
import {
  greenGift,
  greenGiftClaimed,
} from '../assets';
import {
  type ChallengeMedia
} from '../model';

export type ChallengeGiftImageProps = {
  claimed: boolean
  giftClaimedImage: ChallengeMedia;
  giftUnclaimedImage: ChallengeMedia
};

export const ChallengeGiftImage: FC<ChallengeGiftImageProps> = ({
  claimed,
  giftClaimedImage,
  giftUnclaimedImage
}) => {
  return (
    <Fragment>
      {claimed ? (
        <Box
          zIndex={1}
          width={69}
          height={64}
          component='img'
          marginBottom={claimed ? 1.5 : -1}
          src={giftClaimedImage?.url || greenGiftClaimed.default}
        />
      ) : (
        <Box
          zIndex={1}
          width={69}
          height={64}
          component='img'
          marginBottom={claimed ? 1 : -1}
          src={giftUnclaimedImage?.url || greenGift.default}
        />
      )}
    </Fragment>
  );
};